var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "unser-service" }, [
    _c("div", { staticClass: "image-container" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "34",
            height: "34",
            viewBox: "0 0 34 34"
          }
        },
        [
          _c("g", { attrs: { fill: "#FFF" } }, [
            _c("path", {
              attrs: {
                d:
                  "M4.41814976,6.67942309 C9.09051674,1.21275981 16.8020332,-0.529555379 23.3708093,2.39732023 C24.1155068,2.72913803 24.4502119,3.60182609 24.1183941,4.34652357 C23.7865763,5.09122104 22.9138882,5.42592615 22.1691907,5.09410834 C16.7947375,2.69939193 10.485315,4.12492254 6.66246929,8.59764705 C2.83962358,13.0703716 2.41401995,19.5248128 5.61645962,24.4607822 C8.81889929,29.3967516 14.886508,31.6384194 20.5288732,29.9701482 C26.0430028,28.3397923 29.867295,23.3547533 30.041418,17.6380865 L30.047619,17.2380952 L30.047619,15.88 C30.047619,15.0647225 30.708532,14.4038095 31.5238095,14.4038095 C32.2808529,14.4038095 32.9047963,14.9736784 32.9900686,15.707845 L33,15.88 L33,17.2389393 C32.995888,24.4302816 28.2622009,30.7623708 21.3659768,32.8013689 C14.4697526,34.8403671 7.05378642,32.1005509 3.13969349,26.0676994 C-0.774399437,20.0348479 -0.254217218,12.1460864 4.41814976,6.67942309 Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M30.4794637,4.38526891 C31.0556638,3.80849265 31.9903358,3.80802554 32.567112,4.38422561 C33.0995209,4.9161026 33.1408734,5.75342312 32.6908881,6.33274461 L32.5681553,6.47187394 L17.8062506,21.2485406 C17.2741856,21.7811376 16.4365077,21.8223057 15.8571987,21.371904 L15.7180805,21.2490624 L11.289509,16.820491 C10.7130208,16.2440027 10.7130208,15.3093306 11.289509,14.7328424 C11.821652,14.2006994 12.6589931,14.1597653 13.2380897,14.6100401 L13.3771576,14.7328424 L16.7619048,18.1164286 L30.4794637,4.38526891 Z"
              }
            })
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("p", { staticClass: "size-20 semibold" }, [
          _vm._v(_vm._s(_vm.headline))
        ]),
        _vm._v(" "),
        _vm._l(_vm.listEntries, function(entry) {
          return _c("div", { staticClass: "service-item" }, [
            _c("p", [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "15",
                    height: "10",
                    viewBox: "0 0 15 10"
                  }
                },
                [
                  _c("polygon", {
                    attrs: {
                      fill: "#0090BA",
                      "fill-rule": "evenodd",
                      points:
                        "5.269 18 .258 12.988 1.756 11.489 5.269 14.979 12.763 8 14.262 9.499",
                      transform: "translate(0 -8)"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(entry.text))])
            ])
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "buttons" }, [
      _c(
        "a",
        { staticClass: "btn primary mb-2", attrs: { href: _vm.btnLink1 } },
        [
          _c("div", { staticClass: "icon-wrapper" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "22",
                  viewBox: "0 0 14 22"
                }
              },
              [
                _c("path", {
                  attrs: {
                    fill: "#FFF",
                    d:
                      "M21.5409836,24 L25.1147541,22.9852008 C24.7868852,22.6997886 24.5245902,22.1606765 24.5245902,21.653277 C24.5245902,20.4799154 25.5409836,19.782241 26.6885246,18.9577167 C28.2295082,17.9112051 30,16.6427061 30,14.0105708 C30,11.0613108 27.4098361,9 23.1803279,9 C20.3606557,9 17.7377049,10.1099366 16,12.0761099 L18.6557377,14.961945 C19.6721311,13.7885835 21.0491803,12.9957717 22.6885246,12.9957717 C24.4918033,12.9957717 25.2459016,13.820296 25.2459016,14.8033827 C25.2459016,15.7547569 24.3606557,16.3572939 23.3442623,17.0549683 C22.0327869,17.97463 20.4590164,19.0211416 20.4590164,21.2093023 C20.4590164,22.3192389 20.852459,23.2706131 21.5409836,24 Z M23.5,31 C24.8580247,31 26,29.8580247 26,28.5 C26,27.1419753 24.8580247,26 23.5,26 C22.1419753,26 21,27.1419753 21,28.5 C21,29.8580247 22.1419753,31 23.5,31 Z",
                    transform: "translate(-16 -9)"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-wrapper" }, [
            _c("span", [_vm._v(_vm._s(_vm.btnText1))])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "btn primary", attrs: { href: "tel:" + _vm.btnText2 } },
        [
          _c("div", { staticClass: "icon-wrapper" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "27",
                  viewBox: "0 0 20 27"
                }
              },
              [
                _c("g", { attrs: { fill: "#FFF", "fill-rule": "evenodd" } }, [
                  _c("path", {
                    attrs: {
                      "fill-rule": "nonzero",
                      d:
                        "M15.9545455,0 L3.68181818,0 C1.64840615,0 0,1.64840615 0,3.68181818 L0,23.3181818 C0,25.3515939 1.64840615,27 3.68181818,27 L15.9545455,27 C17.9879575,27 19.6363636,25.3515939 19.6363636,23.3181818 L19.6363636,3.68181818 C19.6363636,1.64840615 17.9879575,0 15.9545455,0 Z M3.68181818,2.45454545 L15.9545455,2.45454545 C16.6323495,2.45454545 17.1818182,3.00401417 17.1818182,3.68181818 L17.1818182,23.3181818 C17.1818182,23.9959858 16.6323495,24.5454545 15.9545455,24.5454545 L3.68181818,24.5454545 C3.00401417,24.5454545 2.45454545,23.9959858 2.45454545,23.3181818 L2.45454545,3.68181818 C2.45454545,3.00401417 3.00401417,2.45454545 3.68181818,2.45454545 Z"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { cx: "9.818", cy: "20.864", r: "1.227" }
                  })
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-wrapper" }, [
            _c("span", [_vm._v(_vm._s(_vm.btnText2))])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }